import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, Platform, ModalController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { Base64 } from '@ionic-native/base64/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-countrylist',
    templateUrl: './countrylistModal.component.html',
    styleUrls: ['./countrylistModal.component.scss'],
})
export class CountryListModal implements OnInit {
    currentpath;
    allcountryLists: any = [];
    filtercountryLists: any = [];
    searchTerm: any;

    constructor(public formBuilder: FormBuilder,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        private camera: Camera,
        public actionSheetController: ActionSheetController,
        private file: File,
        public api: RestapiService,
        public base64: Base64,
        public filePath: FilePath,
        public fileChooser: FileChooser,
        public _DomSanitizer: DomSanitizer,
        public modalCtrl: ModalController,
        public navparam: NavParams) {

        this.currentpath = this.router.url;
        let ncountry = (localStorage.getItem('nomineeCountry'));
        console.log(ncountry);
        this.allcountryLists = ncountry.split(",");
        this.filtercountryLists = this.allcountryLists;
        console.log(this.allcountryLists);



    }
    ngOnInit() { }


    goback(c) {
        this.modalCtrl.dismiss(c);
    }

    gonavback() {
        this.modalCtrl.dismiss();
    }

    filterItems() {
        this.filtercountryLists = this.allcountryLists.filter((contry) => {
            return contry.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
        });
    }

}